import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EmptyCustomSectionColumn from 'ContentEditorUI/components/sections/EmptyCustomSectionColumn';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-ignore Untyped module
import { updateSelectedCategory } from 'ContentEditorUI/redux/actions/sidebarActions';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
// @ts-ignore Untyped module
import { openModal } from 'ContentEditorUI/redux/actions/appActions';
import { PATAGONIA_ADD_PANEL_CATEGORIES } from 'ContentEditorUI/constants/Sidebar';
import { getDefaultSubCategoryMap } from 'ContentEditorUI/redux/selectors/sidebarSelectors';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
export default function InpageNoSavedSectionsMessage() {
  const dispatch = useDispatch();
  const defaultSelectedSubCategoryMap = useSelector(getDefaultSubCategoryMap);
  const layoutsSubCategory = defaultSelectedSubCategoryMap[PATAGONIA_ADD_PANEL_CATEGORIES.LAYOUTS];
  const goToLayoutsCallback = useCallback(() => {
    dispatch(updateSelectedCategory(PATAGONIA_ADD_PANEL_CATEGORIES.LAYOUTS, layoutsSubCategory));
  }, [dispatch, layoutsSubCategory]);
  const createYourOwnCallback = useCallback(() => {
    dispatch(openModal(MODAL_TYPES.SECTIONS_INSTRUCTIONAL_MODAL));
  }, [dispatch]);
  return /*#__PURE__*/_jsx(EmptyCustomSectionColumn, {
    message: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "addSectionPanel.customSections.noSavedSectionsSecondary_jsx",
      options: {
        layoutClick: goToLayoutsCallback,
        createYourOwnClick: createYourOwnCallback
      },
      elements: {
        UILink: Link
      }
    })
  });
}